import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiCall } from '../../utils/apiCall';
import { getApiUrl } from '../../utils/apiHandler';
import { AuthTokenResponse } from '../_declarations/auth';

export const fetchTokenAsync = createAsyncThunk<
  AuthTokenResponse,
  void,
  { rejectValue: Error }
>('auth/fetchToken', async (_, { getState }) => {
  try {
    const state: any = getState();
    if (state.app.testPrupose) {
      return {
        access_token: 'dsadsad',
        expires_in: 3600,
        scope: 'scope',
        token_type: 'Bearer'
      };
    }
    const oAuthUrl = getApiUrl('oAuth');
    const response: AuthTokenResponse = await apiCall({
      data: {
        grantType: 'client_credentials',
        scope: 'read'
      },
      headers: {
        Authorization: `Basic ${btoa(
          `1a354357-d88c-46c9-908e-fae0378892ab:qSrq9438alFQwZJ8YXhNqTS9jT0HFglpY0bzFG9iMi4GK1YhEe`
        )}`
      },
      method: 'POST',
      url: oAuthUrl
    });

    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in fetchTokenAsync:', error);
    throw error;
  }
});
